export default __webpack_public_path__ + "static/w1-3-1-d9409f4a840c98babb0403d773fe3b00.jpg";